import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import getCurrentUser from "../../utils/getCurrentUser";
import CustomDropzone from "../CustomDropzone";
import "./permanent-booking.scss";
import PermanentBookingList from "./PermanentBookingList";
import { useReactToPrint } from "react-to-print";
import { connect } from "react-redux";
import {
    getPermanentBookingFileList,
    getPermanentBookingsForFile,
} from "../../services/permanentService";
import {
    getToastSuccess,
    getToastError,
    getToastInfo,
} from "../../redux/actions/toastActions";
import LoadingIndicator from "../LoadingIndicator";
import { pushPageData } from "../../utils/analytics";
import pageNames from "../../constants/pageNames";
import {
    PAGE_PRIMARY_CATEGORY,
    PAGE_SUB_CATEGORY1,
    BOOKING_PAGE_SUB_CATEGORY2,
} from "../../constants";
import downloadIcon from "../../assets/images/downloadIconBlue.svg";
import {
    getBase64Decoded,
    getFromSessionStorage,
} from "../../utils/StorageUtils";
import sessionKeys from "../../constants/sessionKeys";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const PermanentBooking = ({ getToastSuccess, getToastError }) => {
    const { t, i18n } = useTranslation(["labels", "errors"]);

    const userDetails = getCurrentUser();

    const sessionStorageData = getFromSessionStorage(
        sessionKeys.MULTIPLE_BOOKING_DATA
    );
    const decryptedData = ![undefined, null].includes(sessionStorageData)
        ? getBase64Decoded(sessionStorageData)
        : undefined;

    const [displayUploadSection, setDisplayUploadSection] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [isListPageOpen, setListPageOpen] = useState(false);
    const [fileName, setFileName] = useState("");
    const [bookingList, setBookingList] = useState([]);
    const [clearToken, setClearToken] = useState(null);
    const [isEditButtonActive, setEditButtonActive] = useState(false);
    const [isRefreshActive, setRefreshActive] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [flag, setFlag] = useState(false);
    const [toasterFlag, setToasterFlag] = useState(true);

    const location = useLocation();
    const detailsFromCallerScreen = location?.state;

    useEffect(() => {
        // handleFileListLoad();
        if (fileName === "") {
            setInitialList();
        }
        pushPageData(
            pageNames.MULTIPLE_BOOKING,
            PAGE_PRIMARY_CATEGORY.E_SERVICES,
            PAGE_SUB_CATEGORY1.BOOKING,
            BOOKING_PAGE_SUB_CATEGORY2.MULTIPLE_BOOKING,
            "Mass uplaod"
        );
    }, []);

    useEffect(() => {
        if (!(fileName && fileName.length)) return;
        setTimeout(() => {
            handleFileNameSelect(fileName);
        }, 500);
        if (clearToken) {
            clearInterval(clearToken);
            //setClearToken(null);
            setEditButtonActive(false);
        }
    }, [fileName]);

    const setDropDownFileList = (list) => {
        setFileList(list);
    };

    const setInitialList = async () => {
        const res = await getPermanentBookingFileList();
        setDropDownFileList(res.permanentBookingDetails);
        if (res.permanentBookingDetails?.length > 0) {
            const defaultSelectedFile =
                decryptedData?.fileName || res.permanentBookingDetails[0].fileName;
            handleFileNameSelect(defaultSelectedFile, true);
            setListPageOpen(true);
            setFileName(defaultSelectedFile);
        }
    };

    const setListPage = (e) => {
        e.stopPropagation();
        setListPageOpen(false);
    };

    const setMainPage = (e) => {
        e.stopPropagation();
        setListPageOpen(true);
    };

    const getBookingListData = (fileNameParam) => {
        let counter = 0;
        let token = setInterval(async () => {
            const bookingViewList = await getPermanentBookingsForFile(fileNameParam);
            if (
                bookingViewList?.bookingList &&
                bookingViewList.bookingList.length > 0
            ) {
                clearInterval(token);
                setLoading(false);
                setBookingList(bookingViewList);
                let statusList = [];
                bookingViewList?.bookingList.map((item) => {
                    statusList.push(item.status);
                });
                if (statusList.includes("Loading")) {
                    setRequest();
                    setEditButtonActive(true);
                    setRefreshActive(true);
                } else {
                    setRefreshActive(false);
                }
            } else {
                if (counter >= 2) {
                    setLoading(false);
                    clearInterval(token);
                    setBookingList(bookingViewList);
                }
                counter++;
            }
        }, 3000);
    };

    const handleFileNameSelect = async (fileNameParam, isInitialLoad) => {
        setLoading(true);
        const { bookingGrpId } = detailsFromCallerScreen || {};
        try {
            const bookingViewList = await getPermanentBookingsForFile(fileNameParam);
            if (
                bookingViewList?.bookingList &&
                bookingViewList.bookingList.length === 0
            ) {
                getBookingListData(fileNameParam);
            } else {
                setLoading(false);
                setBookingList(bookingViewList);

                let statusList = [];
                let editedItem = null;
                bookingViewList?.bookingList.map((item) => {
                    statusList.push(item.status);
                    if (
                        bookingGrpId &&
                        isInitialLoad &&
                        item.bookingGroupId === bookingGrpId
                    ) {
                        editedItem = item;
                    }
                });
                if (statusList.includes("Loading")) {
                    setRequest();
                    setEditButtonActive(true);
                    setRefreshActive(true);
                } else if (bookingGrpId && editedItem) {
                    if (editedItem.status == "Failed") {
                        getToastError("Resubmission Failed");
                    } else if (
                        ["Confirmed", "To be Processed", "Queued"].includes(
                            editedItem.status
                        )
                    ) {
                        getToastSuccess("Resubmission successful");
                    }
                    setRefreshActive(false);
                } else {
                    setRefreshActive(false);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    //>>>> auto refesh of list in every 5 sec <<<<
    const setRequest = (submitGrpId = null) => {
        let token;
        let reprocessid = submitGrpId;
        let toasterFlagLocal = true;
        token = setInterval(async () => {
            setRefreshActive(true);
            let statusList = [];
            let fileSelected = fileName;
            const bookingViewList = await getPermanentBookingsForFile(fileSelected);
            setBookingList(bookingViewList);
            bookingViewList?.bookingList?.map((item) => {
                statusList.push(item.status);
                if (reprocessid == item.bookingGroupId) {
                    if (item.status == "Failed" && toasterFlagLocal) {
                        getToastError("Resubmission Failed");
                        toasterFlagLocal = false;
                    } else if (
                        item.status == "Confirmed" ||
                        item.status == "To be Processed" ||
                        item.status == "Queued"
                    ) {
                        if (toasterFlagLocal) {
                            getToastSuccess("Resubmission successful");
                            toasterFlagLocal = false;
                        }
                    }
                    // else{
                    //     getToastSuccess("Booking is Success")
                    // }
                }
            });
            if (!statusList.includes("Loading")) {
                clearInterval(token);
                setEditButtonActive(false);
                setRefreshActive(false);
            }
        }, 5000);
        setClearToken(token);
    };

    const componentRef = useRef();

    const getPrintTemplate = () => {
        if (componentRef.current) {
            const clone = componentRef?.current?.cloneNode(true);
            const printHeader = document?.createElement('div');
            printHeader.className = 'print-header';
            printHeader.innerHTML = `
                <label class="head-label" >File Name:</label>
                <label class="file-value" >${fileName}</label>
                <label class="head-label" >Booking list:</label>
            `;
            clone?.insertBefore(printHeader, clone.firstChild);
            // Wrap in a print-section container
            const container = document?.createElement('div');
            container.className = 'print-section';
            container.appendChild(clone);
            return container;
        }
        return null;
    };

    const handlePrint = useReactToPrint({
        //onBeforeGetContent: () => {setFlag(true)},
        content: () => getPrintTemplate(),
        onAfterPrint: () => {
            setFlag(false);
        },
    });

    const handleClose = () => {
        setFlag(true);
        setTimeout(() => {
            console.log(componentRef.current);
            handlePrint();
        }, 1000);
    };

    return userDetails ? (
        <>
            {!isListPageOpen ? (
                <React.Fragment>
                    <div className="mutiple-book-new-upload-row">
                        <div className="article-show-section">
                            <span className="article-heading">
                                {t("PERMANENT_BOOKING.TEXT_YOU_ARE")}
                            </span>
                            <span className="article-body">
                                {t("PERMANENT_BOOKING.TEXT_DWNLOAD")} <br />
                            </span>
                            <ul className="article-list">
                                <li className="mb-3">{t("PERMANENT_BOOKING.TEXT_BOOK_REQ")}</li>
                                <li className="mb-3">{t("PERMANENT_BOOKING.TEXT_ALLOT_ID")}</li>
                                <li>{t("PERMANENT_BOOKING.TEXT_BOOKING_LIMIT")}</li>
                            </ul>
                        </div>
                        <div className="template-download-section">
                            <img
                                src={downloadIcon}
                                alt="download"
                                title="download"
                                id="download-icon"
                            />
                            <a
                                className="template-download_button"
                                tabIndex={-1}
                                href={
                                    process.env.PUBLIC_URL + "/Booking_upload_template_v4.xlsx"
                                }
                                role="button"
                                target="_blank"
                            >
                                {t("PERMANENT_BOOKING.DOWNLOAD_TMP")}
                            </a>
                        </div>
                    </div>
                    <CustomDropzone
                        setDisplayUploadSection={setDisplayUploadSection}
                        setDropDownFileList={setDropDownFileList}
                        fileList={fileList}
                        setListPageOpen={setListPageOpen}
                        setFileName={setFileName}
                        setFileList={setFileList}
                        fileName={fileName}
                    />
                    {fileName ? (
                        <div className="footer-button-row">
                            <button
                                type="submit"
                                value="Submit"
                                className="primary-button"
                                onClick={(e) => {
                                    setMainPage(e);
                                    setInitialList("");
                                }}
                            >
                                {t("COMMON.BACK_BUTTON")}
                            </button>
                        </div>
                    ) : (
                        <></>
                    )}
                </React.Fragment>
            ) : (
                <></>
            )}
            {isLoading ? <LoadingIndicator /> : ""}
            {isListPageOpen ? (
                <React.Fragment>
                    <PermanentBookingList
                        flag={flag}
                        setDropDownFileList={setDropDownFileList}
                        fileList={fileList}
                        setListPageOpen={setListPageOpen}
                        fileName={fileName}
                        setFileName={setFileName}
                        bookingList={bookingList}
                        setBookingList={setBookingList}
                        // handleFileNameSelect={handleFileNameSelect}
                        setRequest={setRequest}
                        setEditButtonActive={setEditButtonActive}
                        isEditButtonActive={isEditButtonActive}
                        ref={componentRef}
                        clearToken={clearToken}
                        isRefreshActive={isRefreshActive}
                        toasterFlag={toasterFlag}
                        setToasterFlag={setToasterFlag}
                        isMassUpload={true}
                    />
                    <div className="footer-button-row">
                        <button
                            type="submit"
                            value="Submit"
                            className="primary-button"
                            onClick={handleClose}
                        >
                            {t("COMMON.PRINT")}
                        </button>
                        <button
                            type="button"
                            className="secondary-button"
                            onClick={(e) => {
                                clearInterval(clearToken);
                                setListPage(e);
                                setBookingList([]);
                            }}
                        >
                            {t("PERMANENT_BOOKING.NEW_UPLOAD")}
                        </button>
                    </div>
                </React.Fragment>
            ) : (
                <></>
            )}
        </>
    ) : (
        <></>
    );
};
const mapStateToProps = ({ loader, toast }) => ({
    //	principal: auth.principal,
    //	isLoading: loader.isLoading,
    toastDetails: toast.toastDetails,
});
const mapDispatchToProps = (dispatch) => ({
    getToastSuccess: (message) => {
        dispatch(getToastSuccess(message));
    },
    getToastError: (message) => {
        dispatch(getToastError(message));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(PermanentBooking);
